import { intervalToDuration } from "date-fns";
import type React from "react";
import { useEffect, useState } from "react";

import { Badge } from "@/design-system/Badge";
import { useTranslation } from "@/translations";

import { ClockIcon } from "../Icons/ClockIcon";

interface CountdownBadgeProps {
  endDate: Date;
}

export function CountdownBadge({ endDate }: CountdownBadgeProps): React.ReactNode {
  const [nowDate, setNowDate] = useState(() => new Date());

  const { t } = useTranslation();

  useEffect(() => {
    const interval = setInterval(() => {
      setNowDate(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const duration = intervalToDuration({
    start: nowDate,
    end: endDate,
  });
  const amountDaysLeft = duration.days ?? 0;
  const amountHoursLeft = duration.hours ?? 0;
  // If less than a minute is left, we show "01M"
  const amountMinutesLeft = duration.minutes ?? 1;

  return (
    <Badge icon={<ClockIcon />} variant="info">
      {endDate > nowDate ? (
        <span>{`${amountDaysLeft.toString().padStart(2, "0")}D : ${amountHoursLeft.toString().padStart(2, "0")}H : ${amountMinutesLeft.toString().padStart(2, "0")}M`}</span>
      ) : (
        <span>{t("common.label.ended")}</span>
      )}
    </Badge>
  );
}
